import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAllVendorDetailsExtractFromSAP = createApi(`GetAllVendorForecastExtractFromSAPSlice`,"GET");

const GetAllVendorForecastExtractFromSAPSlice = createSlice({
  name: 'GetAllVendorForecastExtractFromSAPSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllVendorDetailsExtractFromSAP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllVendorDetailsExtractFromSAP.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllVendorDetailsExtractFromSAP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAllVendorForecastExtractFromSAPSlice.reducer;